/* import __COLOCATED_TEMPLATE__ from './get-started-with-email-templates.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();